
  import {defineComponent, computed, PropType, Ref} from "vue";
  import EmployeeAutocomplete from "@/components/EmployeeAutocomplete.vue";
  import { TaskForm } from "@/model/OrderTaskImport";
  import EmployeeName from "@/model/EmployeeName";

  export default defineComponent({
    name: "InventoriesTasksForm",
    components: {
      EmployeeAutocomplete
    },
    props: {
      task: {
        required: true,
        type: Object as PropType<TaskForm>
      },
      orders: {
        required: true,
        type: Array as PropType<Array<{ label: string; orderId: string }>>
      },
      edit: {
        type: Boolean,
        default: false
      },
      errors: {
        required: false,
        type: Map as PropType<Map<string, string | Ref<string>>>,
        default: () => new Map<string, string>()
      }
    },
    setup(props, context) {

      const taskInputModel = computed({
        get(): TaskForm {
          return props.task;
        },
        set(newValue: TaskForm) {
          context.emit("taskChanged", newValue);
        },
      });

      const onSelectOrder = (orderId: string) => {
        taskInputModel.value = {
          ...taskInputModel.value,
          orderId
        };
      };

      const onSelectEmployee = (employee: EmployeeName | null) => {
        taskInputModel.value = {
          ...taskInputModel.value,
          employee
        };
      };

      return {
        taskInputModel,
        onSelectOrder,
        onSelectEmployee
      };
    }
  });
